import React from "react";
import "./status-badge.css";
import { StatusVariant } from "utils/merchant";



interface Props {
  status: StatusVariant;
  /** Override the display label; defaults to capitalised status */
  label?: string;
}

function StatusBadge({ status, label }: Props) {
  const text = label ?? status.charAt(0).toUpperCase() + status.slice(1);
  return (
    <span className={`status-badge status-badge--${status}`}>{text}</span>
  );
}

export default StatusBadge;
